module.exports = __webpack_public_path__ + "img/plans.5922c16e.svg";